import { configs } from './config';
export const Api = {
    user:{
        login:`/${configs.default.serv}/${configs.default.verv}/login`,
        list:`/${configs.default.serv}/${configs.default.verv}/users/list`,
        create:`/${configs.default.serv}/${configs.default.verv}/users`,
        reset:`/${configs.default.serv}/${configs.default.verv}/users/reset/`,
        delete:`/${configs.default.serv}/${configs.default.verv}/users/`,
        bind_group:`/${configs.default.serv}/${configs.default.verv}/users/group`,
        export:`/${configs.default.serv}/${configs.default.verv}/users/export`,
    },
    group:{
        list:`/${configs.default.serv}/${configs.default.verv}/groups/list`,
        parent_list:`/${configs.default.serv}/${configs.default.verv}/groups/parent/list`,
        create:`/${configs.default.serv}/${configs.default.verv}/groups`,
        info:`/${configs.default.serv}/${configs.default.verv}/groups/`,
        bind_custom:`/${configs.default.serv}/${configs.default.verv}/groups/custom`,
        bind_role:`/${configs.default.serv}/${configs.default.verv}/groups/role`,
        edit:`/${configs.default.serv}/${configs.default.verv}/groups/`,
        all:`/${configs.default.serv}/${configs.default.verv}/groups/all`,
    },
    customs:{
        list:`/${configs.default.serv}/${configs.default.verv}/custom/list`,
        create:`/${configs.default.serv}/${configs.default.verv}/custom`,
        get:`/${configs.default.serv}/${configs.default.verv}/custom/`,
        edit:`/${configs.default.serv}/${configs.default.verv}/custom/edit`,
    },
    battery_event:{
        list:`/${configs.default.serv}/${configs.default.verv}/battery/imei/`,
    },
    role:{
        list:`/${configs.default.serv}/${configs.default.verv}/role/list`,
        create:`/${configs.default.serv}/${configs.default.verv}/role`,
        edit:`/${configs.default.serv}/${configs.default.verv}/role/edit/`,
        perm:`/${configs.default.serv}/${configs.default.verv}/role/perms/`,
        perm_bind:`/${configs.default.serv}/${configs.default.verv}/role/bind`,
        info:`/${configs.default.serv}/${configs.default.verv}/role/`
    },
    perm:{
        list:`/${configs.default.serv}/${configs.default.verv}/perms/list`,
        // create:`/${configs.default.serv}/${configs.default.verv}/role`,
        // edit:`/${configs.default.serv}/${configs.default.verv}/role/edit/`
    },
    search:{
        list:`/${configs.default.serv}/${configs.default.verv}/finances/search/`
    },
    operation:{
        list:`/${configs.default.serv}/${configs.default.verv}/operation/list`,
        export:`/${configs.default.serv}/${configs.default.verv}/operation/export`
    },
    finance:{
        list:"",
        upload:`/${configs.default.serv}/${configs.default.verv}/finances`,
    },
    dashboard:{
        low_remind:`/${configs.default.serv}/${configs.default.verv}/dashboard/battery/low`,
        off_remind:`/${configs.default.serv}/${configs.default.verv}/dashboard/battery/off`,
        activation_group:`/${configs.default.serv}/${configs.default.verv}/dashboard/activation/list`,
        activation_sum:`/${configs.default.serv}/${configs.default.verv}/dashboard/activation/sum`,
        activity_pie:`/${configs.default.serv}/${configs.default.verv}/dashboard/activity`,
        device_nums:`/${configs.default.serv}/${configs.default.verv}/dashboard/device`,
        activity_date:`/${configs.default.serv}/${configs.default.verv}/dashboard/activity/date`,
        nfc_charts:`/${configs.default.serv}/${configs.default.verv}/dashboard/nfc/charts`,
        nfc_charts_date:`/${configs.default.serv}/${configs.default.verv}/dashboard/nfc/chart_date`,
        banner:`/${configs.default.serv}/${configs.default.verv}/dashboard/banner`,
        kind:`/${configs.default.serv}/${configs.default.verv}/dashboard/kind/stat`,

  
    },
    device_finance:{
        info:`/${configs.default.serv}/${configs.default.verv}/device_finance/`,
        update:`/${configs.default.serv}/${configs.default.verv}/device_finance`,
        reminder:`/${configs.default.serv}/${configs.default.verv}/device_finance/reminder`,
        stop_reminder:`/${configs.default.serv}/${configs.default.verv}/device_finance/stop_reminder`,
        set_duedate:`/${configs.default.serv}/${configs.default.verv}/device_finance/set_duedate`,
        clear_conflict:`/${configs.default.serv}/${configs.default.verv}/device_finance/clear`,
    },
    device:{
        device_imei:`/${configs.default.serv}/${configs.default.verv}/device/imeis`,
        device_lock:`/${configs.default.serv}/${configs.default.verv}/device/lock`,
        device_unlock:`/${configs.default.serv}/${configs.default.verv}/device/unlock`,
        factory:`/${configs.default.serv}/${configs.default.verv}/device/factory`,
        stop_factory:`/${configs.default.serv}/${configs.default.verv}/device/factory/stop`,
        eraseCID:`/${configs.default.serv}/${configs.default.verv}/device/erase_cid`,
        ping:`/${configs.default.serv}/${configs.default.verv}/device/ping`,
        create:`/${configs.default.serv}/${configs.default.verv}/device/bind`,
        device_bind:`/${configs.default.serv}/${configs.default.verv}/device/bind/custom`,
        import:`/${configs.default.serv}/${configs.default.verv}/device/import`,
        edit:`/${configs.default.serv}/${configs.default.verv}/device/edit`,
        export:`/${configs.default.serv}/${configs.default.verv}/device/export`,
        clearActivation:`/${configs.default.serv}/${configs.default.verv}/device/clear/activation`,
        permanentlyLock:`/${configs.default.serv}/${configs.default.verv}/device/permanent/lock`

        // create:`/${configs.default.serv}/${configs.default.verv}/role`,
        // edit:`/${configs.default.serv}/${configs.default.verv}/role/edit/`
    },
}